import img1 from "../../images/image.avif";
import img2 from "../../images/image4.avif";
import img3 from "../../images/image2.avif";
import img4 from "../../images/image3.avif";

export const CommunityData = [
	{
		id: 1,
		img: img1,
		heading: "Juan",
		paragraph:
			"The easiest way to understand DeFi is to get your hands dirty. The Trinet Wallet dApp Browser helped me to use protocols with small amounts and learn what works and what doesn't work.",
	},
	{
		id: 2,
		img: img2,
		heading: "Jen",
		paragraph:
			"Secure your private keys like your life depends on it. #DoNotShare 🔑",
	},
	{
		id: 3,
		img: img3,
		heading: "Harry",
		paragraph:
			"As a newcomer in this field, the introduction of blockchain technology has had a profound and transformative impact on my life. It has opened up an entirely new realm of possibilities that I am eager to explore.",
	},
	{
		id: 4,
		img: img4,
		heading: "Esmart",
		paragraph:
			"I thoroughly enjoy engaging with DeFi and have developed a passion for minting token. However, I always make it a point to conduct my own research and consistently check the Trinet Wallet Security Scanner prior to any acquisition. By following these Web3 security practices, I ensure my safety and stay #SAFU. 🛡️",
	},
];
